import { getCookie, setCookie, updateCookie, getBrowserType } from "../core/utils.js";
// import { initCampaign } from "../components/campaign-info.js";

let code = "",
    ccode = "",
    leads_referrer = document.referrer;

export function waba() {
    var waba_buttons = document.querySelectorAll(".cta-waba");
    if (waba_buttons.length > 0) {
        waba_buttons.forEach((button) => {
            button.classList.add("show");
            button.addEventListener("click", function (e) {
                e.preventDefault();

                document.querySelectorAll(".has-loading").forEach(function (element) {
                    element.style.display = "flex";
                });

                var curr_lang = document.documentElement.getAttribute("lang")
                    ? document.documentElement.getAttribute("lang")
                    : "id";

                var url_string = window.location.href;
                var url = new URL(url_string);
                var browserType = getBrowserType();
                var gclid_date = new Date();
                var gclid_DD = (gclid_date.getDate() < 10 ? "0" : "") + gclid_date.getDate();
                var gclid_MM = (gclid_date.getMonth() + 1 < 10 ? "0" : "") + parseInt(gclid_date.getMonth() + 1);
                var gclid_YY = gclid_date.getFullYear().toString().slice(2);
                var gclid_hh = (gclid_date.getHours() < 10 ? "0" : "") + gclid_date.getHours();
                var gclid_mm = (gclid_date.getMinutes() < 10 ? "0" : "") + gclid_date.getMinutes();
                var gclid_ss = gclid_date.getSeconds();
                var gclid_ms = gclid_date.getMilliseconds();
                var gclid_sh = gclid_DD + gclid_MM + gclid_YY + gclid_hh + gclid_mm + gclid_ss + gclid_ms;
                var gclid = url.searchParams.get("gclid") || getCookie("gclid") || "";
                var msclkid = url.searchParams.get("msclkid") || getCookie("msclkid") || "";
                var umedium = url.searchParams.get("utm_medium") || getCookie("utm_medium") || "";
                var ucampaign = url.searchParams.get("utm_campaign") || getCookie("utm_campaign") || "";
                var usource = url.searchParams.get("utm_source") || getCookie("utm_source") || "";
                var utm_term = url.searchParams.get("utm_term") || getCookie("utm_term") || "";
                var matchtype = url.searchParams.get("matchtype") || getCookie("matchtype") || "";
                var devicetype = "desktop";
                var gclidmsclkid = "";

                // var banner_click = getCookie("banner_click") || "";

                var banner_journey = getCookie("banner_journey") || "";
                var cta_journey = getCookie("cta_journey") || "";
                var cta_last_click = getCookie("cta_last_click") || "";
                var medium_code = getCookie("waba_code") || "";
                var campaign_code = getCookie("medium_code") || "";

                var text_truncate = function (str, length, ending) {
                    if (length == null) {
                        length = 100;
                    }
                    if (ending == null) {
                        ending = "...";
                    }
                    if (str.length > length) {
                        return str.substring(0, length - ending.length) + ending;
                    } else {
                        return str;
                    }
                };

                var firstlanding = "";

                if (getCookie("user_journey")) {
                    var journey_ = getCookie("user_journey");
                    journey_ = journey_.split("|");
                    if (journey_.length > 1) {
                        firstlanding = journey_[0].replace("M", "");
                    }
                }

                if (
                    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                        navigator.userAgent
                    ) ||
                    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                        navigator.userAgent.substr(0, 4)
                    )
                ) {
                    devicetype = "mobile";
                } else {
                    devicetype = "desktop";
                }

                var temp = this.getAttribute("href");

                if (temp) {
                    var ticketPrefix =
                        curr_lang && curr_lang.toLowerCase().indexOf("en") === 0
                            ? "Ticket number: [P" + gclid_sh + "] Do not remove this code.\n\n "
                            : "Nomor tiket: [P" + gclid_sh + "] Jangan hapus kode ini.\n\n ";
                    var fallbackMsg =
                        curr_lang && curr_lang.toLowerCase().indexOf("en") === 0
                            ? "Hello, I want to ask more about Mekari POS"
                            : "Halo, Saya tertarik dengan fitur Mekari POS";

                    // If the button's href already carries a custom "{{code}} - <message>" text
                    // (set from PHP/ACF), keep that message instead of the generic fallback.
                    var extractCustomMsg = function (text) {
                        if (!text || text.indexOf("{{code}}") === -1) return "";
                        return text.replace("{{code}}", "").replace(/^\s*-\s*/, "").trim();
                    };

                    try {
                        var tempUrl = new URL(temp);
                        var customMsg = extractCustomMsg(tempUrl.searchParams.get("text"));
                        tempUrl.searchParams.set("text", ticketPrefix + (customMsg || fallbackMsg));
                        temp = tempUrl.toString();
                    } catch (error) {
                        var customMsg = extractCustomMsg(temp);
                        var ticketText = ticketPrefix + (customMsg || fallbackMsg);
                        temp = temp.replace("{{code}}", "[P" + gclid_sh + "]");

                        if (temp.includes("text=")) {
                            temp = temp.replace(/([?&]text=)([^&]*)/, "$1" + encodeURIComponent(ticketText));
                        } else {
                            temp += (temp.indexOf("?") >= 0 ? "&" : "?") + "text=" + encodeURIComponent(ticketText);
                        }
                    }
                }

                // Set value to hidden form
                var f_gclid_short = document.querySelector("#f_gclid_short"),
                    f_gclid = document.querySelector("#f_gclid"),
                    f_device = document.querySelector("#f_device"),
                    f_utmsource = document.querySelector("#f_utmsource"),
                    f_utmmedium = document.querySelector("#f_utmmedium"),
                    f_utmcampaign = document.querySelector("#f_utmcampaign"),
                    f_utmterm = document.querySelector("#f_utmterm"),
                    f_banner_id = document.querySelector("#f_banner_id"),
                    f_gclid_journey = document.querySelector("#f_gclid_journey"),
                    f_matchtype = document.querySelector("#f_matchtype"),
                    f_label = document.querySelector("#f_label"),
                    f_phone_number = document.querySelector("#f_phone_number"),
                    f_visitor_id = document.querySelector("#f_visitor_id");



                let phone_number = "";
                if (temp) {
                    // Check for wa.me format
                    const phoneMatch = temp.match(/wa\.me\/(\d+)\?/);
                    if (phoneMatch && phoneMatch[1]) {
                        phone_number = phoneMatch[1];
                    } else {
                        // Check for api.whatsapp.com format
                        const apiPhoneMatch = temp.match(/api\.whatsapp\.com\/send\/\?phone=(\d+)/);
                        if (apiPhoneMatch && apiPhoneMatch[1]) {
                            phone_number = apiPhoneMatch[1];
                        }
                    }
                }

                if (f_phone_number) {
                    f_phone_number.value = phone_number;
                }

                if (f_gclid_short) {
                    f_gclid_short.value = gclid_sh;
                }

                if (f_gclid) {
                    gclidmsclkid = text_truncate(gclid + "|" + msclkid, 250, "");
                    f_gclid.value = gclidmsclkid;
                }

                if (f_utmsource) {
                    f_utmsource.value = (usource === "chatgpt.com") ? "website" : usource;
                }

                if (f_utmmedium) {
                    f_utmmedium.value = umedium;
                }

                if (f_utmcampaign) {
                    f_utmcampaign.value = ucampaign;
                }

                if (f_utmterm) {
                    f_utmterm.value = utm_term;
                }

                if (f_matchtype) {
                    f_matchtype.value = matchtype;
                }

                if (f_banner_id) {
                    f_banner_id.value = banner_journey;
                }

                if (f_device) {
                    if (devicetype == "desktop") {
                        f_device.value = "Desktop";
                    } else {
                        f_device.value = "Mobile";
                    }
                }

                var waba_redirect = document.querySelector("#waba_redirect");
                if (waba_redirect) {
                    waba_redirect.value = temp;
                }

                var label = "";
                // Get CTA ID and Label
                if (this.classList.contains("ic-wa")) {
                    label = "ID: " + this.id + ", Label: Sticky WABA";
                } else if (this.classList.contains("top-banner-sticky") || this.classList.contains("top-banner-bot")) {
                    label = "ID: " + this.id + ", Label: Sticky Banner";
                } else if (this.id != "") {
                    label = "ID: " + this.id + ", Label: " + this.innerText;
                } else {
                    label = "ID: , Label: " + this.innerText;
                }

                var cta_journey_url = "";
                if (cta_journey != "") {
                    if (cta_last_click != "") {
                        if (cta_last_click != button.id) {
                            cta_journey_url = cta_journey + "|" + label;
                        } else {
                            cta_journey_url = cta_journey;
                        }
                    } else {
                        cta_journey_url = label;
                    }
                } else {
                    cta_journey_url = label;
                }

                if (f_label) f_label.value = cta_journey_url;

                if (getCookie("cta_journey")) {
                    updateCookie("cta_journey", cta_journey_url);
                } else {
                    setCookie("cta_journey", cta_journey_url, 31);
                }

                if (getCookie("cta_last_click")) {
                    updateCookie("cta_last_click", button.id);
                } else {
                    setCookie("cta_last_click", button.id, 31);
                }

                if (this.classList.contains("top-banner-sticky") || this.classList.contains("top-banner-bot")) {
                    var today = new Date(),
                        year = today.getFullYear().toString().slice(-2),
                        month = (today.getMonth() + 1).toString();
                    if (month.length === 1) {
                        month = "0" + month;
                    }
                    var formattedDate = year + month;

                    if (bc_cookie != "") {
                        if (f_banner_id) {
                            f_banner_id.value = bc_cookie;
                        }
                    } else {
                        if (f_banner_id) {
                            f_banner_id.value = formattedDate;
                        }
                    }
                }

                if (f_gclid_journey) {
                    f_gclid_journey.value = getCookie("gclid_journey") || "";
                }

                var f_journey = document.querySelector("#f_journey"),
                    f_gaid = document.querySelector("#f_gaid");

                if (f_journey) {
                    var limit_journey = text_truncate(getCookie("user_journey"), 240, "");
                    f_journey.value = limit_journey;
                }

                if (f_gaid) {
                    if (getCookie("gaid")) {
                        f_gaid.value = getCookie("gaid");
                    } else {
                        if (getCookie("_ga")) {
                            f_gaid.value = getCookie("_ga").slice(6);
                        }
                    }
                }

                var f_browser = document.querySelector("#f_browser");
                if (f_browser) {
                    f_browser.value = browserType;
                }

                if (f_visitor_id) {
                    f_visitor_id.value = getCookie("visitor_id") || "";
                }

                document.querySelectorAll(".has-loading").forEach(function (element) {
                    element.style.display = "none";
                });

                if (browserType === "Apple Safari (iOS)") {
                    // Buka tab kosong
                    const newTab = window.open("about:blank", "_blank");

                    // Jika tab berhasil dibuka, ganti URL setelah jeda
                    if (newTab) {
                        setTimeout(() => {
                            newTab.location.href = temp;
                        }, 200); // Jeda 100ms untuk memastikan tab terbuka
                    }
                } else {
                    window.open(temp, "_blank").focus();
                }

                const scriptURL =
                    "https://script.google.com/macros/s/AKfycbyxNWoblx9TZ-kydRQnvlYCkGFucAVPGDpsBM2TVy5adIOyxmkjlXU6637V4rNaugtZ/exec";
                const form = document.forms["form-shortener-gclid"];

                // window.open($url, '_blank');
                fetch(scriptURL, { method: "POST", body: new FormData(form) })
                    .then((response) => {
                        document.querySelectorAll(".has-loading").forEach(function (element) {
                            element.style.display = "none";
                        });
                        if (response.status == 200) {
                            // newTab.location.href = $url;
                            document.querySelectorAll(".has-loading").forEach(function (element) {
                                element.style.display = "none";
                            });
                        } else {
                            console.error("Response code : ", response.status);
                            document.querySelectorAll(".has-loading").forEach(function (element) {
                                element.style.display = "none";
                            });
                            // newTab.close();
                        }
                    })
                    .catch((error) => {
                        console.error("Error!", error.message);
                        document.querySelectorAll(".has-loading").forEach(function (element) {
                            element.style.display = "none";
                        });
                    });
            });
        });
    }
}
